import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PURPOSE_REQUIRES_CUSTOMER } from '../constants/otrEnums';

export const useOTRValidation = () => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});

  const validateOTRForm = (formData) => {
    const newErrors = {};

    if (!formData.dateOfTravel) newErrors.dateOfTravel = 'Date of travel is required';
    if (!formData.dateOfReturn) newErrors.dateOfReturn = 'Date of return is required';
    if (formData.dateOfTravel && formData.dateOfReturn) {
      if (new Date(formData.dateOfReturn) < new Date(formData.dateOfTravel)) {
        newErrors.dateOfReturn = 'Return date cannot be before travel date';
      }
    }

    if (!formData.placeOfTravel) newErrors.placeOfTravel = 'Place of travel is required';
    if (!formData.modeOfTravelId) newErrors.modeOfTravelId = 'Mode of travel is required';
    if (!formData.purpose) newErrors.purpose = 'Purpose is required';

    if (PURPOSE_REQUIRES_CUSTOMER.includes(formData.purpose) && !formData.customer?.trim()) {
      newErrors.customer = t('outstation.customerRequired');
    }

    if (formData.advanceRequested < 0) {
      newErrors.advanceRequested = 'Advance request cannot be negative';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateExpenseLine = (lineData) => {
    const newErrors = {};

    if (!lineData.expenseHeadId) newErrors.expenseHeadId = 'Expense head is required';
    if (lineData.amount <= 0) newErrors.amount = 'Amount must be greater than zero';
    if (!lineData.entryDate) newErrors.entryDate = 'Date is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return {
    errors,
    validateOTRForm,
    validateExpenseLine,
    clearErrors: () => setErrors({}),
  };
};